<template>
  <div>
    <v-row>
      <v-col cols="3">
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="false"
          type="card">
          <div>
            <v-card flat color="transparent" class="border-radius" v-if="Object.keys(form).length > 0">
              <v-img 
                contain
                width="100%"
                height="auto"
                min-height="270"
                alt="property"
                style="border-radius: 20px;"
                gradient="to top right, rgba(0,0,0,.3), rgba(0,0,0,.3)"
                :src="form.company.company_logo === null ? require('@/assets/image/no-image-available.jpg') : form.company.company_logo">
                <image-input v-model="images">
                  <div slot="activator">
                    <v-btn
                      v-if="edit.general"
                      rounded
                      block
                      color="#000"
                      class="text-capitalize white--text"
                      elevation="0"
                      style="position: absolute; bottom: 0px; width: 100%; opacity: 50%;">
                      <v-icon color="white" class="cursor-pointer mr-2">mdi-camera-outline</v-icon> Ubah Gambar
                    </v-btn>
                  </div>
                </image-input>
              </v-img>
            </v-card>
          </div>
        </v-skeleton-loader>
      </v-col>

      <v-col cols="9">
        <v-skeleton-loader
          class="ma-auto"
          :loading="process.run"
          transition="scale-transition"
          :tile="false"
          type="list-item-three-line">
          <div>
            <!-- PERUSAHAAN -->
            <v-card flat class="pa-3" style="background: rgb(255, 255, 255, 0.1);" v-if="Object.keys(form).length > 0 && !edit.general">
              <v-card-title class="body-2 font-weight-bold d-flex align-center py-0">
                <div>
                  Perusahaan
                </div>
                <v-spacer/>
                <div class="body-2 color-default cursor-pointer" 
                  v-if="user.user_company_roles_name.includes('superuser') || user.user_company_roles_name.includes('administrator')"
                  @click="edit.general = true; edit.password = false; reset();">
                  <v-icon small :color="style.primary" class="mr-1">mdi-account-edit-outline</v-icon>
                  Ubah Perusahaan
                </div>
              </v-card-title>
              <v-divider class="my-2 mx-4"/>
              <v-card-text>
                <p class="body-2 mb-2 font-weight-bold">
                  <v-icon small class="mr-1">mdi-home-city-outline</v-icon>
                  Nama Perusahaan
                </p>
                <p class="body-2 mb-2 pl-6">
                  {{ form.company.company_name === '' ? '-' : form.company.company_name }}
                </p>
                <p class="body-2 mb-2 font-weight-bold">
                  <v-icon small class="mr-1">mdi-account-tie-outline</v-icon>
                  Nama Pemilik
                </p>
                <p class="body-2 mb-2 pl-6">
                  {{ form.company.company_contact_name === '' ? '-' : form.company.company_contact_name }}
                </p>
                <p class="body-2 mb-2 font-weight-bold">
                  <v-icon small class="mr-1">mdi-email-outline</v-icon>
                  Alamat Email
                </p>
                <p class="body-2 mb-2 pl-6">
                  {{ form.company.company_contact_email === '' ? '-' : form.company.company_contact_email }}
                </p>
                <p class="body-2 mb-2 font-weight-bold">
                  <v-icon small class="mr-1">mdi-cellphone-iphone</v-icon>
                  Nomor Handphone
                </p>
                <p class="body-2 mb-2 pl-6">
                  {{ form.company.company_contact_mobilephone === '' ? '-' : form.company.company_contact_mobilephone }}
                </p>
                <p class="body-2 mb-2 font-weight-bold">
                  <v-icon small class="mr-1">mdi-phone-classic</v-icon>
                  Nomor Telepon
                </p>
                <p class="body-2 mb-2 pl-6">
                  {{ form.company.company_contact_phone === null || form.company.company_contact_phone === '' ? '-' : form.company.company_contact_phone }}
                </p>
              </v-card-text>
              <v-card-text class="py-0">
                <p class="body-2 font-weight-bold mb-2">
                  Alamat :
                </p>
                <p class="body-2 mb-2" v-if="Object.keys(form).length > 0">
                  <span>
                    {{ Object.keys(form.company.company_address).length > 0 ? form.company.company_address : '-' }}
                  </span>
                </p>
                <p class="body-2 mb-2">
                  {{ form.company.company_province_name === null || form.company.company_province_name === '' || form.company.company_province_name === '-' ? '' : `${form.company.company_province_name},` }}
                  {{ form.company.company_city_name === null || form.company.company_city_name === '' || form.company.company_city_name === '-' ? '' : `${form.company.company_city_name}` }}
                </p>
              </v-card-text>
              <v-card-text class="py-0">
                <p class="body-2 font-weight-bold mb-2">
                  Keterangan :
                </p>
                <p class="body-2 mb-2" v-if="Object.keys(form).length > 0">
                  <span class="line-text-second" 
                    v-if="form.company.company_detail !== null && form.company.company_detail !== ''" 
                    v-html="form.company.company_detail">
                  </span>
                  <span v-else>
                    -
                  </span>
                </p>
              </v-card-text>
            </v-card>

            <!-- UBAH -->
            <v-card flat class="pa-3" style="background: rgb(255, 255, 255, 0.1);" v-if="Object.keys(form).length > 0 && edit.general">
              <v-card-title class="body-2 font-weight-bold d-flex align-center py-0">
                <div>
                  Perusahaan
                </div>
                <v-spacer/>
                <div class="body-2 red--text cursor-pointer" @click="edit.general = false">
                  <v-icon small color="red" class="mr-1">mdi-close</v-icon>
                  Batal
                </div>
              </v-card-title>
              <v-divider color="white" class="my-2 mx-4"/>
              <v-card-text class="pb-0">
                <p class="body-2">
                  Silahkan masukkan informasi data diri anda, kemudian tekan tombol <b>Update Perusahaan</b>.
                </p>
                <ValidationObserver ref="observer">
                  <v-form class="mb-3">
                    <p class="caption mb-2">
                      <span class="red--text">*</span>
                      <b>Nama Perusahaan</b>
                    </p>
                    <ValidationProvider name="Nama Perusahaan" rules="required" v-slot="{ errors }">
                      <v-text-field
                        style="width: 50%;"
                        dense
                        outlined
                        single-line
                        :color="style.primary"
                        placeholder="Nama Perusahaan"
                        prepend-inner-icon="mdi-account-circle-outline"
                        v-model="form.company.company_name"
                        :error-messages="errors"
                        require>
                      </v-text-field>
                    </ValidationProvider>

                    <p class="caption mb-2">
                      <span class="red--text">*</span>
                      <b>Nama Pemilik</b>
                    </p>
                    <ValidationProvider name="Nama Pemilik" rules="required" v-slot="{ errors }">
                      <v-text-field
                        style="width: 50%;"
                        dense
                        outlined
                        single-line
                        :color="style.primary"
                        placeholder="Nama Pemilik"
                        prepend-inner-icon="mdi-account-tie-outline"
                        v-model="form.company.company_contact_name"
                        :error-messages="errors"
                        require>
                      </v-text-field>
                    </ValidationProvider>
                    
                    <p class="caption mb-2">
                      <span class="red--text">*</span>
                      <b>Alamat Email</b>
                    </p>
                    <ValidationProvider name="Alamat Email" rules="required|email" v-slot="{ errors }">
                      <v-text-field
                        style="width: 40%;"
                        dense
                        outlined
                        single-line
                        :color="style.primary"
                        placeholder="Alamat Email"
                        prepend-inner-icon="mdi-email-outline"
                        v-model="form.company.company_contact_email"
                        :error-messages="errors"
                        require>
                      </v-text-field>
                    </ValidationProvider>
                    
                    <p class="caption mb-2">
                      <span class="red--text">*</span>
                      <b>Nomor Handphone</b>
                    </p>
                    <ValidationProvider name="Nomor Handphone" rules="required|min:10|max:13" v-slot="{ errors }">
                      <v-text-field
                        style="width: 40%;"
                        dense
                        outlined
                        single-line
                        :color="style.primary"
                        placeholder="Nomor Handphone"
                        prepend-inner-icon="mdi-cellphone-iphone"
                        type="number"
                        :counter="13"
                        v-model="form.company.company_contact_mobilephone"
                        :error-messages="errors"
                        require>
                      </v-text-field>
                    </ValidationProvider>

                    <p class="caption mb-2">
                      <span class="red--text">*</span>
                      <b>Nomor Telepon</b>
                    </p>
                    <ValidationProvider name="Nomor Telepon" rules="required|min:10|max:13" v-slot="{ errors }">
                      <v-text-field
                        style="width: 40%;"
                        dense
                        outlined
                        single-line
                        :color="style.primary"
                        placeholder="Nomor Telepon"
                        prepend-inner-icon="mdi-phone-classic"
                        type="number"
                        :counter="13"
                        v-model="form.company.company_contact_phone"
                        :error-messages="errors"
                        require>
                      </v-text-field>
                    </ValidationProvider>

                    <p class="caption cursor-pointer d-flex align-center" @click="edit.address = !edit.address ? true : false">
                      <v-icon>{{ !edit.address ? 'mdi-chevron-down' : 'mdi-chevron-up' }}</v-icon>
                      <span v-if="!edit.address">
                        Anda bisa menambahkan <b>alamat</b> disini
                      </span>
                      <span v-else>
                        <b>Alamat</b> (bisa dikosongi)
                      </span>
                    </p>
                    
                    <div v-if="edit.address">
                      <p class="caption mb-2">
                        <b>Detail Alamat</b>
                      </p>
                      <div style="width: 60%;"
                        class="v-input v-input--dense theme--light v-text-field v-text-field--is-booted v-text-field--enclosed v-text-field--outlined">
                        <div class="v-input__control">
                          <div class="v-input__slot">
                            <div class="v-input__prepend-inner">
                              <div class="v-input__icon v-input__icon--prepend-inner">
                                <i aria-hidden="true" class="v-icon notranslate mdi mdi-home-map-marker theme--light"></i>
                              </div>
                            </div>
                            <fieldset aria-hidden="true">
                              <legend style="width: 0px;">
                                <span>​</span>
                              </legend>
                            </fieldset>
                            <div class="v-text-field__slot">
                              <label for="input-147" class="v-label theme--light" style="left: 0px; right: auto; position: absolute;">
                                <!-- Alamat / Lokasi -->
                              </label>
                              <gmap-autocomplete placeholder="Alamat / Lokasi Perusahaan" 
                                :value="form.company.company_address" 
                                :select-first-on-enter="true" 
                                @place_changed="setPlace">
                              </gmap-autocomplete>
                            </div>
                          </div>
                          <div class="v-text-field__details">
                            <div class="v-messages theme--light">
                              <div class="v-messages__wrapper">
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <v-row>
                        <v-col cols="12" md="5">
                          <p class="caption mb-2">
                            <b>Provinsi</b>
                          </p>
                          <v-select
                            dense
                            outlined
                            single-line
                            :color="style.primary"
                            placeholder="ex: DI Yogyakarta"
                            :items="config.province"
                            item-value="province_id"
                            item-text="province_name"
                            item-color="color-first"
                            v-model="form.company.company_province_id"
                            v-on:change="form.company.company_city_id = ''; form.company.company_city_name = '';">
                            <template v-slot:append>
                              <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                            </template>
                          </v-select>
                        </v-col>
                        <v-col cols="12" md="5">
                          <p class="caption mb-2">
                            <b>Kabupaten</b>
                          </p>
                          <v-select
                            dense
                            outlined
                            single-line
                            :color="style.primary"
                            placeholder="ex: Kab. Sleman"
                            :items="config.city"
                            item-value="city_id"
                            item-text="city_name"
                            item-color="color-first"
                            :disabled="form.company.company_province_id === null"
                            v-model="form.company.company_city_id">
                            <template v-slot:append>
                              <v-icon color="#7B7B7B">mdi-chevron-down-box</v-icon>
                            </template>
                          </v-select>
                        </v-col>
                      </v-row>
                    </div>

                    <quill-editor 
                      class="mb-12"
                      ref="myTextEditor"
                      :options="option"
                      v-model="form.company.company_detail">
                    </quill-editor>
                    
                    <v-alert 
                      style="width: 80%;"
                      type="error" 
                      text
                      prominent
                      v-show="error.message.length > 0"
                      v-html="error.message">
                    </v-alert>
                    
                    <v-btn
                      style="width: 40%;"
                      rounded
                      color="#333333"
                      class="white--text text-capitalize"
                      :loading="process.form"
                      :disabled="process.form"
                      @click="save">
                      Update Perusahaan
                    </v-btn>
                  </v-form>
                </ValidationObserver>
              </v-card-text>
            </v-card>
          </div>
        </v-skeleton-loader>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { get, post, put, destroy } from "@/service/Axios";
  import ImageInput from "@/components/ImageInput.vue";
  export default {
    data () {
      return {
        option: {
          modules: {
            toolbar: [
              ['bold', 'italic', 'underline'],
              [{ 'list': 'ordered'}, { 'list': 'bullet' }],
              [{ 'size': ['small', false, 'large', 'huge'] }],
              [{ 'color': [] }, { 'background': [] }],
              [{ 'align': [] }]
            ]
          },
          placeholder: 'Keterangan'
        },
        edit: {
          general: false,
          address: true
        },
        images: {
          url: ''
        },
        config: {
          province: [],
          city: []
        },
        center: {
          lat: 0,
          lng: 0
        },
        form: {},
        process: {
          run: false,
          form: false
        },
        error: {
          message: ''
        },
        style: {
          primary: "#8BC541"
        }
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      }
    },
    watch: {
      images: {
        handler: function () {
          if (this.images) {
            this.form.company.company_logo = this.images.url
          }
        },
        deep: true
      },
      'form.company.company_province_id': function() {
        let t = this
        let p = this.config.province.filter(function(v) {
          return t.form.company.company_province_id == v.province_id
        })

        if (p.length > 0) {
          this.form.company.company_province_name = p[0].province_name
        }

        this.setting().city()
      },
      'form.company.company_city_id': function() {
        let t = this
        let c = this.config.city.filter(function(v) {
          return t.form.company.company_city_id == v.city_id
        })

        if (c.length > 0) {
          this.form.company.company_city_name = c[0].city_name
        }
      }
    },
    components: {
      ImageInput
    },
    mounted () {
      this.fetch()
      this.setting().province()
      this.getGeoLocation()
    },
    methods: {
      fetch() {
        this.process.run = true
        get(`auth/company/user/profile`)
        .then(response => {
          let res = response.data
          if (res.status == 200) {
            this.process.run = false
            this.form = res.data
          }
        })
      },
      setting() {
        let t = this
        return {
          async province() {
            get(`location/get-province`)
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.province = res.data.province
              }
            })
          },
          async city() {
            get(`location/get-city`, {
              params: { province_id: t.form.company.company_province_id }
            })
            .then(response => {
              let res = response.data;
              if (res.status == 200) {
                t.config.city = res.data.city
              }
            })
          }
        }
      },
      getGeoLocation() {
        navigator.geolocation.getCurrentPosition(position => {
          this.center = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        })
      },
      setPlace(place) {
        this.center = {
          lat: place.geometry.location.lat(),
          lng: place.geometry.location.lng()
        }

        // this.form.latitude = place.geometry.location.lat()
        // this.form.longitude = place.geometry.location.lng()

        this.form.company.company_address = place.formatted_address
      },
      reset() {
        this.images = {
          url: this.form.company.company_logo
        }

        this.process = {
          run: false,
          form: false
        }

        this.error.message = ''
      },
      async save() {
        this.error.message = ''
        const isValid = await this.$refs.observer.validate()
        if (isValid) {
          this.process.form = true
          await post(`auth/company/company/update`, {
            data: {
              name: this.form.company.company_name,
              contact_name: this.form.company.company_contact_name,
              contact_email: this.form.company.company_contact_email,
              contact_mobilephone: this.form.company.company_contact_mobilephone,
              contact_phone: this.form.company.company_contact_phone,
              logo_url: this.form.company.company_logo,
              address: this.form.company.company_address,
              province_id: this.form.company.company_province_id,
              province_name: this.form.company.company_province_name,
              city_id: this.form.company.company_city_id,
              city_name: this.form.company.company_city_name,
              detail: this.form.company.company_detail
            }
          }).then(response => {
            let res = response.data
            if (res.status === 200) {
              this.edit.general = false

              this.reset()
              this.fetch()
            } else {
              this.process.form = false
              this.error.message = res.msg
            }
          })
        }
      }
    }
  }
</script>